import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';

export const StyledTitleModal = styled.p`
  ${pickThemeFontStyles('24', '30', 'NORMAL')};
  margin-bottom: 1.5rem;
`;

export const StyledSubTitleModal = styled.p`
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
  margin-bottom: 1.5rem;
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
`;

export const StyledCancelButton = styled(Button)`
  &&& {
    min-height: 2.5rem;
  }
`;

export const StyledConfirmButton = styled(Button)`
  &&& {
    min-height: 2.5rem;
    color: ${COLORS.RED};
  }
`;
